import { fg } from '@atlassian/jira-feature-gating';

const BoardRovoContextualActions = {
	get(): boolean {
		return fg('jira_boards_rovo_contextual_actions_experiment_eligibility');
	},
};

export default BoardRovoContextualActions;
